'use client'

import { useTranslations } from '@/lib/next-shim'
import { useExpertiseDetail } from '../model/useExpertiseDetail'
import { Expertise, ExpertiseFormSubmissions } from '../lib/expertise-detail.types'
import { DetailHeader } from './DetailHeader'
import { PractitionerCard } from './PractitionerCard'
import { TextSection } from './TextSection'
import { ConsultationsSection } from './ConsultationsSection'
import { FilesSection } from './FilesSection'
import { FormsSection } from './FormsSection'
import { ChatPanel } from './ChatPanel'

type ExpertiseDetailProps = {
  expertise: Expertise
  onClose: () => void
  submissions: ExpertiseFormSubmissions
}

export function ExpertiseDetail({ expertise, onClose, submissions }: ExpertiseDetailProps) {
  const t = useTranslations()
  const { statusText, speciality, expert, pds, formSubmissions } = useExpertiseDetail({ expertise, submissions })

  return (
    <div className="flex w-full flex-col gap-6">
      <DetailHeader speciality={speciality} status={expertise.status} statusText={statusText} startDate={expertise.startDate} onClose={onClose} />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Left column */}
        <div className="min-w-0 space-y-6">
          <PractitionerCard {...expert} />
          {pds && <PractitionerCard {...pds} />}
          <TextSection title={t('account.expertises.diagnostic')} content={expertise.diagnostic} />
          <TextSection title={t('account.expertises.comment')} content={expertise.comment} />
          <ConsultationsSection consultations={expertise.consultations ?? []} />
          <FilesSection files={expertise.files} expertiseId={expertise._id} />
          <FormsSection submissions={formSubmissions} expertiseId={expertise._id} />
        </div>

        {/* Right column - chat */}
        <ChatPanel expertise={expertise} />
      </div>
    </div>
  )
}
